"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

type CustomToasterProps = Omit<ToasterProps, "closeButton"> & {
	showCloseButton?: boolean
}

const Toaster = ({ showCloseButton = false, ...props }: CustomToasterProps) => {
	const { theme = "system" } = useTheme()

	return <Sonner theme={theme as ToasterProps["theme"]} closeButton={showCloseButton} {...props} />
}

export { Toaster }
